<template>
  <div class="activity-info-wrapper">
    <div class="info-row margin-bottom-10" v-if="!isDashboard">
      <img class="margin-right-5" src="@/assets/images/icons/players-icon.png" alt="players icon">
      <span>
        <span class="text-gray margin-right-5">{{$t('CALENDAR_ACTIVITY.activityHeader.players')}}: </span>
        <span class="">{{activityInfo.numberOfPlayers}}</span>
      </span>
    </div>
    <div class="info-row margin-bottom-10">
      <img class="margin-right-5" src="@/assets/images/icons/coach-icon.png" alt="coach icon">
      <span>
        <span class="text-gray margin-right-5">{{$t('CALENDAR_ACTIVITY.activityHeader.coach')}}: </span>
        <!-- <span class="text-white" v-if="!activityInfo.recordedByCaptain">
          {{activityInfo.coachFirstName}} {{activityInfo.coachMiddleName}} {{activityInfo.coachLastName}}
        </span>
        <span class="text-white" v-if="activityInfo.recordedByCaptain">
          {{$t('CALENDAR_ACTIVITY.activityHeader.teamCaptain')}}
        </span> -->
         <span class="text-white">
          {{activityInfo.coachFirstName}} {{activityInfo.coachMiddleName}} {{activityInfo.coachLastName}}
        </span>
      </span>
    </div>
    <div class="info-row margin-bottom-10">
      <img class="margin-right-5" src="@/assets/images/icons/session-icon.png" alt="session icon">
      <span>
        <span class="text-gray margin-right-5">{{$t('CALENDAR_ACTIVITY.activityHeader.sessionType')}}: </span>
        <span class="" ng-if="!activityHeaderCtrl.editActivityTypeOpened">{{sessionTypeLabel}}</span>
      </span>
    </div>
</div>
</template>

<script>
import { SESSION_TYPES } from '@/constants/SessionConsts'

export default {
  name: 'CalendarActivityInfo',
  props: [
    'activityInfo',
    'isDashboard'
  ],
  data() {
    return {
      activityTypes: SESSION_TYPES
    }
  },
  computed: {
    sessionTypeLabel () {
      switch(this.activityInfo.type) {
        case this.activityTypes.GAME:
          return this.$t('CALENDAR_ACTIVITY.activityHeader.sessionTypes.game')
        case this.activityTypes.OTHER:
          return this.$t('CALENDAR_ACTIVITY.activityHeader.sessionTypes.other')
        case this.activityTypes.TRAINING:
          return this.$t('CALENDAR_ACTIVITY.activityHeader.sessionTypes.training')
        case this.activityTypes.INDIVIDUAL:
          return this.$t('CALENDAR_ACTIVITY.activityHeader.sessionTypes.individual')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .activity-info-wrapper {
    display: table;
    width: 100%;
    table-layout: fixed;

    .img-wrapper {
        display: table-cell;
        width: 80px;
        vertical-align: middle;

        img {
          max-width: 60px;
        }
    }

    .info-row span {
      font-size: 14px;
    }

    .duration-info {
        display: table-cell;
        text-align: right;
        width: 40px;

        .duration-value, .unit-value {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            top: 0;
            margin: auto;
            height: 14px;
            width: 100%;
            text-align: center;
            font-size: 14px;
        }

        .unit-value {
            font-size: 9px;
            bottom: -26px;
        }
    }

    .info {
        display: table-cell;
        vertical-align: middle;
    }

    .activity-btn {
        padding: 2px 6px;
        vertical-align: unset;
    }

    .activity-types-select-group {
        width: auto;

        .filter-btn {
            padding: 0 5px;
            height: 26px;
        }
    }
}
</style>
